function active_toggle__init() {
    if( document.querySelector('[data-active]') ) {
        document.querySelectorAll('[data-active] [data-active-toggle]').forEach((e) => {
            let container = e.parentElement;
            e.addEventListener('click', () => {
                if( container.getAttribute('data-active') == 'false' ) {
                    container.setAttribute('data-active', 'true');
                } else {
                    container.setAttribute('data-active', 'false');
                }
            })
        });
    }
}

jQuery(document).ready(function() {
    active_toggle__init();
});

